<template>
  <div>
    <!-- BOC:[error] -->
    <AError :api="api"></AError>
    <!-- EOC -->
    <!-- BOC:[form] -->
    <v-form ref="form" lazy-validation @submit.prevent="validate">
      <v-card>
        <v-card-title>{{
          $t("view.PageBackendEvent.edit_title")
        }}</v-card-title>
        <v-card-text>
          <template>
            <Series
              :value="form['seriesId']"
              @input="form['seriesId'] = $event"
            />
          </template>
          <template>
            <Game
              :value="form['gameCode']"
              @input="form['gameCode'] = $event"
            />
          </template>
          <template>
            <FormInput :value="form['name']" @input="form['name'] = $event" />
          </template>
          <template>
            <FormDate
              :callbackSelect="selectDate"
              formKey="dateStart"
              :name="$t('model.prop.dateStart')"
              :value="form.dateStart"
            />
          </template>
          <template>
            <FormTime
              :callbackSelect="selectTime"
              formKey="timeStart"
              :name="$t('model.prop.timeStart')"
              :value="form.timeStart"
            />
          </template>
          <template>
            <FormDate
              :callbackSelect="selectDate"
              formKey="dateEnd"
              :name="$t('model.prop.dateEnd')"
              :value="form.dateEnd"
            />
          </template>
          <template>
            <FormTime
              :callbackSelect="selectTime"
              formKey="timeEnd"
              :name="$t('model.prop.timeEnd')"
              :value="form.timeEnd"
            />
          </template>
          <template>
            <Visibility
              :value="form['visibility']"
              @input="form['visibility'] = $event"
            />
          </template>
          <template>
            <FormRadio
              :value="form['isDisabledTicket']"
              label="Disabled Ticket"
              @input="form['isDisabledTicket'] = $event"
            />
          </template>
          <template>
            <FormRadio
              :value="form['isDisabledTutorial']"
              label="Disabled Tutorial"
              @input="form['isDisabledTutorial'] = $event"
            />
          </template>
          <template>
            <FormRadio
              :value="form['isDisabledQuest']"
              label="Disabled Quest"
              @input="form['isDisabledQuest'] = $event"
            />
          </template>
            <template>
            <FormRadio
              :value="form['isDisabledFinisher']"
              label="Disabled Finisher"
              @input="form['isDisabledFinisher'] = $event"
            />
          </template>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="$router.go(-1)">
            {{ $t("action.cancel") }}
          </v-btn>
          <v-btn color="primary" :loading="api.isLoading" @click="validate">
            {{ $t("action.confirm") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </div>
</template>

<script>
import Game from "@/components/Moderator/Event/Game";
import Series from "@/components/Moderator/Event/Series";
import FormInput from "@/components/Moderator/Event/FormInput";
import FormDate from "@/components/Moderator/Event/FormDate";
import FormTime from "@/components/Moderator/Event/FormTime";
import Visibility from "@/components/Moderator/Event/Visibility";
import FormRadio from "@/components/Moderator/Event/FormRadio";

import moment from "moment";
import { mapState } from "vuex";
export default {
  props: ["self", "role", "model", "url", "action", "callbackSuccess"],
  components: {
    Game,
    Series,
    FormInput,
    FormDate,
    FormTime,
    Visibility,
    FormRadio
  },
  computed: mapState({
    school: (state) => state.school.data,
  }),
  data: () => ({
    //BOC:[api]
    api: {
      isLoading: false,
      isError: false,
      error: null,
      url: null,
    },
    //EOC
    //BOC:[form]
    form: {
      id: null,
      gameCode: null,
      seriesId: null,
      name: null,
      dateStart: moment().format("YYYY-MM-DD"),
      dateEnd: moment().add(5, "days").format("YYYY-MM-DD"),
      timestampStart: moment().toISOString(),
      timestampEnd: moment().toISOString(),
      timeStart: "08:00",
      timeEnd: "23:00",
      visibility: "public",
      isDisabledTicket: false,
      isDisabledTutorial: false,
      isDisabledFinisher: false,
      isDisabledQuest: false,
    },
    fields: [],
    rules: {},
    //EOC
  }),

  created() {
    //BOC:[api]
    this.api.url = this.url;
    this.api.callbackReset = () => {
      this.api.isLoading = true;
      this.api.isError = false;
      this.api.error = null;
    };
    this.api.callbackError = (e) => {
      this.api.isLoading = false;
      this.api.isError = true;
      this.api.error = e;
    };
    this.api.callbackSuccess = (resp) => {
      this.api.isLoading = false;
      this.callbackSuccess(resp);
    };
    //EOC
  },
  methods: {
    selectDate(date, key) {
      if (key == "dateStart") {
        this.form.dateStart = date;
      } else {
        this.form.dateEnd = date;
      }
    },
    selectTime(time, key) {
      if (key == "timeStart") {
        this.form.timeStart = time;
      } else {
        this.form.timeEnd = time;
      }
    },
    //BOC:[form]
    validate() {
      this.api.callbackReset();
      if (this.$refs.form.validate()) {
        this.form.timestampStart = moment(
          this.form.dateStart + " " + this.form.timeStart
        ).toISOString();
        this.form.timestampEnd = moment(
          this.form.dateEnd + " " + this.form.timeEnd
        ).toISOString();
        if (this.form.timestampStart > this.form.timestampEnd) {
          this.api.callbackError(
            "The event start date and time should be less than the event end date and time."
          );
        } else {
          this.submit();
        }
      } else {
        this.api.callbackError("Please check the form.");
      }
    },
    submit() {
      this.api.params = this.$_.clone(this.form);
      this.$api.fetch(this.api);
    },
    //EOC
  },
  mounted() {
    this.form.id = this.$route.params.id;
    this.form.name = this.self.name;
    this.form.gameCode = this.self.gameCode;
    this.form.seriesId = this.self.seriesId;
    this.form.dateStart = moment(this.self.timestampStart).format("YYYY-MM-DD");
    this.form.dateEnd = moment(this.self.timestampEnd).format("YYYY-MM-DD");
    this.form.timeStart = moment(this.self.timestampStart).format("HH:mm");
    this.form.timeEnd = moment(this.self.timestampEnd).format("HH:mm");
    this.visibility = this.self.visibility;
    this.form.isDisabledTicket = this.self.isDisabledTicket;
    this.form.isDisabledTutorial = this.self.isDisabledTutorial;
    this.form.isDisabledFinisher = this.self.isDisabledFinisher;
    this.form.isDisabledQuest = this.self.isDisabledQuest;
  },
};
</script>

<style>
</style>